import type { Locale } from './enums.js';

/**
 * Currency stays PLN in both locales — a Ukrainian-speaking customer in Poland pays in
 * złoty. Only the number and date formatting is localised.
 */
const INTL_LOCALE: Record<Locale, string> = { pl: 'pl-PL', uk: 'uk-UA' };

export function formatPrice(amountMinor: number, locale: Locale, currency = 'PLN'): string {
  return new Intl.NumberFormat(INTL_LOCALE[locale], {
    style: 'currency',
    currency,
    minimumFractionDigits: 2,
  }).format(amountMinor / 100);
}

export function formatNumber(value: number, locale: Locale, digits = 2): string {
  return new Intl.NumberFormat(INTL_LOCALE[locale], {
    minimumFractionDigits: 0,
    maximumFractionDigits: digits,
  }).format(value);
}

export function formatDate(value: Date | string, locale: Locale): string {
  const d = typeof value === 'string' ? new Date(value) : value;
  return new Intl.DateTimeFormat(INTL_LOCALE[locale], { dateStyle: 'medium' }).format(d);
}

export function formatDateTime(value: Date | string, locale: Locale): string {
  const d = typeof value === 'string' ? new Date(value) : value;
  return new Intl.DateTimeFormat(INTL_LOCALE[locale], {
    dateStyle: 'medium',
    timeStyle: 'short',
  }).format(d);
}

/** Money is stored in minor units (grosze) everywhere. Never floats in the database. */
export const toMinor = (major: number): number => Math.round(major * 100);
export const toMajor = (minor: number): number => minor / 100;
